export default __webpack_public_path__ + "static/media/user_okara.fb664938.svg";